

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: {
			delay: 50000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};

	var stickyNavSwiper = new Swiper(".swiper-sticky-nav .swiper", {
		// Optional parameters
		preventInteractionOnTransition: true,
		slideToClickedSlide: true,
		slidesPerView: "auto",
		freeMode: true,
		spaceBetween: 0,
		speed: 705,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".swiper-sticky-nav .next",
			prevEl: ".swiper-sticky-nav .prev",
		},
	});
	var textSwiperBanner = new Swiper(".swiper-text-sync .swiper", {
		spaceBetween: 0,
		slidesPerView: "auto",
		speed: 1205,
		lazy: {
			loadPrevNext: true,
		},
	});

	var primarySwiper = new Swiper(".primary-banner .swiper", {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},

		thumbs: {
			swiper: textSwiperBanner,
		},

	});


	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "bullets",
				clickable: true,
				dynamicMainBullets: 1,
			},
		});
	});




	var swiperGrid = new Swiper(".fiel-partner-swiper .swiper", {
		autoplay: {
			delay: 2000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		observer: true,
		spaceBetween: 10,
		observeParents: true,

		breakpoints: {
			200: {
				slidesPerView: 2,
				spaceBetween: 10,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			1280: {
				slidesPerView: 6,
				spaceBetween: 24,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},

		navigation: {
			nextEl: ".fiel-partner-swiper  .next",
			prevEl: ".fiel-partner-swiper  .prev",
		},
	});



	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 4000,
		spaceBetween: 20,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				spaceBetween: 40,
				slidesPerView: 3,
			},

		},
	});




	var projectThumb = new Swiper(".project-thumb .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			476: {
				slidesPerView: 4,
			},
			768: {
				slidesPerView: 5,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
			1400: {
				slidesPerView: 7,
				spaceBetween: 24,
			},
		},
		speed: 500,
		lazy: {
			loadPrevNext: true,
		},
	});
	var projectMain = new Swiper(".project-main .swiper", {
		spaceBetween: 10,
		centeredSlides: true,
		speed: 1205,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".project-thumb  .next",
			prevEl: ".project-thumb  .prev ",
		},
		thumbs: {
			swiper: projectThumb,
		},
	});






}